// material-ui
import { useColorScheme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';

// project imports
import IconButton from 'components/@extended/IconButton';

// assets
import SunOutlined from '@ant-design/icons/SunOutlined';
import MoonOutlined from '@ant-design/icons/MoonOutlined';

// ==============================|| HEADER - LIGHT/DARK MODE TOGGLE ||============================== //
//
// MUI's useColorScheme persists the choice in localStorage (modeStorageKey
// "theme-mode" on the ThemeProvider), so the selection follows the browser.

export default function ThemeModeToggle() {
  const { mode, setMode } = useColorScheme();
  const isDark = mode === 'dark';

  return (
    <Tooltip title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}>
      <IconButton
        color="secondary"
        variant="light"
        aria-label={isDark ? 'switch to light mode' : 'switch to dark mode'}
        onClick={() => setMode(isDark ? 'light' : 'dark')}
        sx={{ color: 'text.primary', bgcolor: 'transparent', fontSize: '1.05rem' }}
      >
        {isDark ? <SunOutlined /> : <MoonOutlined />}
      </IconButton>
    </Tooltip>
  );
}
